import React, { useState, useEffect, forwardRef } from "react";
import useStyles from './styles';
import Widget from '../../components/Widget';

const Pricing = forwardRef((props, ref) => {
    const classes = useStyles();
    const [pricing, setPricing] = useState({...props.pricing});
    const [selectedChargeBy, setSelectedChargeBy] = useState('Tag');

    useEffect(() => {
        if(props !== null && props !== undefined) {
            if (pricing.hourly_charge !== null && pricing.hourly_charge !== undefined && pricing.hourly_charge > 0) {
                setSelectedChargeBy('Hour');
            }
            else {
                setSelectedChargeBy('Tag');
            }
        }
    }, [props.pricing.hourly_charge]);

  return (
    <div className={classes.contentDiv}>
    <Widget
      title="Pricing"
      className={classes.formDisplay}
      disableWidgetMenu
    >
    <div>
    </div>
      <div className={classes.twoColWrapper}>
        {selectedChargeBy === 'Hour' && <><div className={classes.gridCol}><span className={classes.bold}>Hourly charge:</span> </div>
        <div className={classes.gridCol}>${pricing.hourly_charge}</div></>}
        <div className={classes.gridCol}><span className={classes.bold}>Min charge:</span> </div>
        <div className={classes.gridCol}>${pricing.min_charge}</div>
        <div className={classes.gridCol}><span className={classes.bold}>Min cash charge:</span> </div>
        <div className={classes.gridCol}>${pricing.min_cash_charge}</div>
        <div className={classes.gridCol}><span className={classes.bold}>Local travel charge:</span> </div>
        <div className={classes.gridCol}>${pricing.local_travel}</div>
        <div className={classes.gridCol}><span className={classes.bold}>Travel 70 -100km charge:</span> </div>
        <div className={classes.gridCol}>${pricing.seventy_hundred_travel}</div>
        <div className={classes.gridCol}><span className={classes.bold}>Travel >100km charge:</span> </div>
        <div className={classes.gridCol}>${pricing.over_100_travel}</div>
        {selectedChargeBy === 'Tag' && <><div className={classes.gridCol}><span className={classes.bold}>1PH price:</span> </div>
        <div className={classes.gridCol}>${pricing.single_phase_price}</div>
        <div className={classes.gridCol}><span className={classes.bold}>3PH price:</span> </div>
        <div className={classes.gridCol}>${pricing.three_phase_price}</div>
        <div className={classes.gridCol}><span className={classes.bold}>RCD price:</span> </div>
        <div className={classes.gridCol}>${pricing.rcd_m_price}</div>
        <div className={classes.gridCol}><span className={classes.bold}>Fire price:</span> </div>
        <div className={classes.gridCol}>${pricing.fire_price}</div>
        <div className={classes.gridCol}><span className={classes.bold}>First aid price:</span> </div>
        <div className={classes.gridCol}>${pricing.first_aid_price}</div>
        <div className={classes.gridCol}><span className={classes.bold}>Medical price:</span> </div>
        <div className={classes.gridCol}>${pricing.medical_price}</div>
        <div className={classes.gridCol}><span className={classes.bold}>RCD PB price:</span> </div>
        <div className={classes.gridCol}>${pricing.rcd_pb_price}</div>
        <div className={classes.gridCol}><span className={classes.bold}>LG PB price:</span> </div>
        <div className={classes.gridCol}>${pricing.lg_pb_price}</div>
        <div className={classes.gridCol}><span className={classes.bold}>LG M price:</span> </div>
        <div className={classes.gridCol}>${pricing.lg_m_price}</div>
        <div className={classes.gridCol}><span className={classes.bold}>3PH RCD price:</span> </div>
        <div className={classes.gridCol}>${pricing.three_phase_rcd_price}</div>
        <div className={classes.gridCol}><span className={classes.bold}>Microwave price:</span> </div>
        <div className={classes.gridCol}>${pricing.microwave_price}</div>
        <div className={classes.gridCol}><span className={classes.bold}>Non Electrical price:</span> </div>
        <div className={classes.gridCol}>${pricing.non_electrical_price}</div>
        <div className={classes.gridCol}><span className={classes.bold}>Ladder price:</span> </div>
        <div className={classes.gridCol}>${pricing.ladder_price}</div>
        <div className={classes.gridCol}><span className={classes.bold}>AED price:</span> </div>
        <div className={classes.gridCol}>${pricing.aed_price}</div>
        <div className={classes.gridCol}><span className={classes.bold}>EVSE price:</span> </div>
        <div className={classes.gridCol}>${pricing.evse_price}</div></>}
      </div>
    </Widget>
    </div>
  );
//}
});
export default Pricing;
